import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Apollo } from 'apollo-angular';
import { FacturacionService } from 'src/app/services/facturacion.service';
import { LoginService } from 'src/app/services/login.service';
const pdfMake = require('pdfmake/build/pdfmake.js');
import pdfFonts from 'pdfmake/build/vfs_fonts';
import {FACTURA} from './../../../constants/constants'
import { DatePipe } from '@angular/common';




@Component({
  selector: 'app-facturacion-contratista',
  templateUrl: './facturacion-contratista.component.html',
  styleUrls: ['./facturacion-contratista.component.scss']
})
export class FacturacionContratistaComponent implements OnInit {

  public dataSource: any
  public tableColumns: String[]
  userLog:any
  facturas:any
  backgroundFactura:any
  pipe:any
  datosFiscales:any
  @ViewChild(MatPaginator) paginator?: MatPaginator;
  @ViewChild(MatSort) sort?: MatSort;

  constructor(public dialog: MatDialog, private loginService:LoginService, private facturaService:FacturacionService, private apollo:Apollo) {
    this.tableColumns = ['nº factura','concepto' , 'total',  'fecha pago', 'descargar']
    this.userLog = loginService.getUserData()
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
    this.backgroundFactura = FACTURA
    this.pipe = new DatePipe('en-US');
    const contratista = this.userLog.contratista
    this.datosFiscales ='Razón social: ' + contratista.razonSocial + '\n' + 'CIF: ' +contratista.cif + '\n' + 'Dirección: ' + contratista?.direccion?.nombre 
    + ' ' + contratista?.direccion?.numero + '\n' + contratista?.direccion?.localidad + '\n' + contratista?.direccion?.provincia + '\n' 
    + contratista?.direccion?.codigoPostal
    
   }

  ngOnInit(): void {
    this.getFacturasByContratista()
    this.getAllFacturasPago()
  }

  generatePdf(nFactura:any, fecha:any, cantidad:any, concepto:any, unidad:any, base:any, iva:any, formaPago: any, total:any){
    const nFecha = this.pipe.transform(fecha,  'dd/MM/YY')
    const importeIva = (base * iva)/100
    const documentDefinition = { 
      custompageSize: {
        width: 210,
        heigth: 297
      },
      background:[{image: this.backgroundFactura,
        width: 600,
        heigth: 687}],
        info: {
          title: 'factura',
        },
      content: 
        [
          {text: nFactura, style:'idFactura'},
          {text: nFecha, style:'fecha'},
          {text: this.datosFiscales, style:'datos'},
          {text: cantidad, style:'cantidad'},
          {text: concepto, style:'concepto'},
          {text: unidad+'€', style:'unidad'},
          {text: base+'€', style:'total'},
          {text: base+'€', style:'imponible'},
          {text: iva+'%', style:'iva'},
          {text: importeIva+'€', style:'importeIva'},
          {text: formaPago, style: 'formaPago'},
          {text: total+'€', style:'totaliva'},
        ],

        styles:{
          idFactura:{
            margin:[380,2,0,0]
          },
          fecha:{
            margin:[463,-10,0,0]
          },
          datos:{
            margin:[0,90,0,0]
          },
          cantidad:{
            margin:[25,90,0,0]
          },
          concepto:{
            margin:[80,-15,0,0]
          },
          unidad:{
            margin:[350,-15,0,0]
          },
          total:{
            margin:[460,-15,0,0]
          },
          imponible:{
            margin:[25,145,0,0]
          },
          iva:{
            margin:[110,-15,0,0]
          },
          importeIva:{
            margin:[200,-15,0,0]
          },
           formaPago:{
            margin:[25,90,0,0]
          },
          totaliva:{
            margin:[410,-10,0,0]
          }
        }
      
    };
    pdfMake.createPdf(documentDefinition).open();
   }

   getAllFacturasPago() {
    this.apollo.watchQuery<any>({
      query: this.facturaService.getAllFacturasPago(),
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log("facturas pago", data);
          }
      )
  }


  getFacturasByContratista() {
    this.apollo.watchQuery<any>({
      query: this.facturaService.getFacturasByContratista(),
      variables: {
        "id": this.userLog.contratista.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        console.log(data);
        
        this.facturas = data.contratista.facturas.filter((factura:any)=>factura.estado == "factura")
        this.dataSource = new MatTableDataSource(this.facturas)
        this.dataSource.paginator = this.paginator;     
        this.dataSource.sort = this.sort;
          }
      )
  }
}
